export const gender = [
  {
    value: "M",
    label: "Male",
  },
  {
    value: "F",
    label: "Female",
  },
];

export const formInitialValues = {
  fname: "",
  lname: "",
  dob: "",
  gender: "",
  isEhr: false,
};